import { useTranslation } from 'react-i18next'

const useTourVipSolicitation = () => {
  const { t } = useTranslation('tour')
  return [
    {
      selector: '.joyride-tourVipSolicitation-div',
      content: (
        <div>
          <p className="text-primary font-bold">{t('tour.vipModal')}</p>
          <span>{t('tour.vipModalDescription')}</span>
          <div>{t('tour.attentionSection')}</div>
        </div>
      ),
    },
  ]
}

export default useTourVipSolicitation
